import { Button, Heading } from "@ariakit/react";
import { button } from "../common.css";
import { ViewContent } from "../oss/Layout/Layout";
import { view } from "./style.css";

export function FailureView(props: { failure: { type: string } }) {
  return (
    <ViewContent isCentered inlineVariant="narrow">
      <div className={view.container}>
        <Heading className={view.heading}>Something went wrong</Heading>

        <p className={view.description}>
          Error code: <code className={view.code}>{props.failure.type}</code>.
          Try restarting the app.
        </p>

        <div className={view.actions}>
          <Button
            onClick={() => void window.location.replace("/")}
            className={button({})}
          >
            Restart App
          </Button>
        </div>
      </div>
    </ViewContent>
  );
}
